import { Product } from '@inter-ikea-storageone/range';
import { ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import { BestaFrameLegsFeatureSystem } from '@inter-ikea-storageone/range-besta';

const replaceWithDefaultLegs = ({
  coreApi,
  rootState: {
    products: { inMarket: products }
  }
}: BehaviorParameters) => {
  // Make sure there are legs in the scene to be replaced
  const legsInScene = coreApi.entities.getByComponent(ComponentIds.LEG_COMPONENT_ID);
  const selectedEntity = coreApi.entities.findSelectedEntity();

  //If we have no selected entity or legs we should not continue
  if (!selectedEntity || !legsInScene) return null;
  const defaultLegProduct = products.find((p: Product) => p.type === ProductType.BESTA_DEFAULT_LEG);

  if (!defaultLegProduct) return null;

  coreApi
    .getSystem<BestaFrameLegsFeatureSystem>('BestaFrameLegsFeatureSystem')
    ?.setSelectedLeg(defaultLegProduct.coreProductId, false);
  coreApi.entities.unselect(); // TEMP: Remove once Core keeps SelectedComponent after replace // copied from autoFillLegs
};

export default replaceWithDefaultLegs;
